import { styled } from '@mui/material';

export const StyledMessageTime = styled('span')(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
  whiteSpace: 'nowrap',
  marginTop: theme.spacing(0.5),
}));
